import React from 'react'
import BaseButton from '../atoms/BaseButton'
import styles from './FooterSection.module.css'
import logo from '../../assets/images/logo.svg'

export const FooterSection = () => {
    return (
        <footer className={styles.footerWrapper}>
            {/* S6 CTA Banner */}
            <div className={styles.s6Cta}>
                <h2 className={styles.ctaTitle}>Obtain your loan today</h2>
                <BaseButton className={styles.footerCtaBtn}>REQUEST NOW</BaseButton>
            </div>

            {/* Main Footer */}
            <div className={styles.mainFooter}>
                <div className={styles.footerContent}>
                    {/* Left Side */}
                    <div className={styles.footerLeft}>
                        <img src={logo} alt="TrustedOnlineLoans" className={styles.footerLogo} />

                        <ul className={styles.footerLinks}>
                            <li><a href="/start">Home</a></li>
                            <li><a href="/start/contact-us">Contact us</a></li>
                            <li><a href="/start/terms-of-use">Terms of Use</a></li>
                            <li><a href="/start/privacy">Privacy Policy</a></li>
                            <li><a href="/start/do-not-sell-my-information">Do not sell my information</a></li>
                            <li><a href="/start/unsubscribe">Unsubscribe</a></li>
                            <li><a href="/start/partners">Partners</a></li>
                            <li><a href="/start/credit-authorization-agreement">Credit Authorization</a></li>
                        </ul>

                        <p className={styles.footerEmail}>Email: contact@trustedonlineloans.com</p>
                    </div>

                    {/* Right Side */}
                    <div className={styles.footerRight}>
                        <p className={styles.disclaimerText}>
                            Disclaimer: Trustedonlineloans is not an offer or solicitation to lend. We do not make any loan or credit decisions and are not representatives, brokers or agents of any lender. Participating lenders offer loans from $100 up to $15,000. Not all lenders can offer you amounts up to $5,000. Our service is not available in all states. Submission of a request through this website does not guarantee that you will receive a loan offer or an offer you’ll be satisfied with. Funds transfer time may vary depending on your lender and/or financial institution. If you have any questions about your loan, please contact your lеndеr directly. Credit checks may be performed with the three reporting credit bureaus: Experian, Equifax, and TransUnion. Submission of a request means you are authorizing the lenders to check your creditworthiness and your personal details.<br /><br />
                            This service is not a solicitation for loan products and does not constitute a loan offer for any loan products that are prohibited by state law. This service is void where prohibited.<br /><br />
                            State Availability: Not all lenders from our system operate in all US states. Residents of some US states may not be eligible for loan products in accordance with their legislation. By selecting your State at the start of our loan offer process, you shall be informed of any limitations regarding obtaining a loan if you reside in individual US states.<br /><br />
                            This website collects personal information and transfers it to its third-party partners.<br /><br />
                            The website contains links to third-party websites. Accessing them may result in a commission.<br /><br />
                            Please note that personal loans should not be treated as financial cure-it-all. If you have major budget difficulties, consult specialists first.
                        </p>
                    </div>
                </div>

                <div className={styles.footerBottom}>
                    <div className={styles.footerBottomContent}>
                        Copyright © 2024 trustedonlineloans.com All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default FooterSection
